export const FETCH_ACHIEVEMENTS = "FETCH_ACHIEVEMENTS";
export const FETCH_ACHIEVEMENTS_PENDING = "FETCH_ACHIEVEMENTS_PENDING";
export const FETCH_ACHIEVEMENTS_REJECTED = "FETCH_ACHIEVEMENTS_REJECTED";
export const FETCH_ACHIEVEMENTS_FULFILLED = "FETCH_ACHIEVEMENTS_FULFILLED";
